import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { prepareComponentToken, prepareToken } from '.';
import { resetComponent } from '../../style';
import { genComponentStyleHook, genPresetColor } from '../../theme/internal';
// ============================== Ribbon ==============================
var genRibbonStyle = function genRibbonStyle(token) {
  var _Object$assign, _Object$assign2, _ref3;
  var antCls = token.antCls,
    badgeFontHeight = token.badgeFontHeight,
    marginXS = token.marginXS,
    badgeRibbonOffset = token.badgeRibbonOffset;
  var ribbonPrefixCls = "".concat(antCls, "-ribbon");
  var ribbonWrapperPrefixCls = "".concat(antCls, "-ribbon-wrapper");
  var statusRibbonPreset = genPresetColor(token, function (colorKey, _ref) {
    var darkColor = _ref.darkColor;
    return _defineProperty({}, "&".concat(ribbonPrefixCls, "-color-").concat(colorKey), {
      background: darkColor,
      color: darkColor
    });
  });
  return _ref3 = {}, _defineProperty(_ref3, "".concat(ribbonWrapperPrefixCls), {
    position: 'relative'
  }), _defineProperty(_ref3, "".concat(ribbonPrefixCls), Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    position: 'absolute',
    top: marginXS,
    padding: "0 ".concat(token.paddingXS, "px"),
    color: token.colorPrimary,
    lineHeight: "".concat(badgeFontHeight, "px"),
    whiteSpace: 'nowrap',
    backgroundColor: token.colorPrimary,
    borderRadius: token.borderRadiusSM
  }, _defineProperty(_Object$assign, "".concat(ribbonPrefixCls, "-text"), {
    color: token.colorTextLightSolid
  }), _defineProperty(_Object$assign, "".concat(ribbonPrefixCls, "-corner"), {
    position: 'absolute',
    top: '100%',
    width: badgeRibbonOffset,
    height: badgeRibbonOffset,
    color: 'currentcolor',
    border: "".concat(badgeRibbonOffset / 2, "px solid"),
    transform: token.badgeRibbonCornerTransform,
    transformOrigin: 'top',
    filter: token.badgeRibbonCornerFilter
  }), _Object$assign)), statusRibbonPreset), (_Object$assign2 = {}, _defineProperty(_Object$assign2, "&".concat(ribbonPrefixCls, "-placement-end"), _defineProperty({
    insetInlineEnd: -badgeRibbonOffset,
    borderEndEndRadius: 0
  }, "".concat(ribbonPrefixCls, "-corner"), {
    insetInlineEnd: 0,
    borderInlineEndColor: 'transparent',
    borderBlockEndColor: 'transparent'
  })), _defineProperty(_Object$assign2, "&".concat(ribbonPrefixCls, "-placement-start"), _defineProperty({
    insetInlineStart: -badgeRibbonOffset,
    borderEndStartRadius: 0
  }, "".concat(ribbonPrefixCls, "-corner"), {
    insetInlineStart: 0,
    borderBlockEndColor: 'transparent',
    borderInlineStartColor: 'transparent'
  })), _defineProperty(_Object$assign2, '&-rtl', {
    direction: 'rtl'
  }), _Object$assign2))), _ref3;
};
// ============================== Export ==============================
export default genComponentStyleHook(['Badge', 'Ribbon'], function (token) {
  var badgeToken = prepareToken(token);
  return [genRibbonStyle(badgeToken)];
}, prepareComponentToken);